export default __webpack_public_path__ + "static/media/codeblock-4x.c60f7986.png";